import React, { useEffect, useState } from "react";
import {
  Table,
  Dropdown,
  Menu,
  message,
  Modal as AntModal,
  Switch,
  Spin,
} from "antd";
import { useNavigate } from "react-router-dom";
import { BsThreeDots } from "react-icons/bs";
import { FaPlus } from "react-icons/fa6";
import ViewAgentModal from "../agents page/view agent modal/ViewAgentModal";
import Instance from "../../AxiosConfig";
import AddManagerModal from "./AddManager";
import EditManagerModal from "./EditManager";

const ManagersList = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]); // 🔥 full data
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
 const [showTargetModal, setShowTargetModal] = useState(false);
const [targetAmount, setTargetAmount] = useState("");
const [applicableFrom, setApplicableFrom] = useState("");
const [targetId, setTargetId] = useState(null);
const [targetLoading, setTargetLoading] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  /* ================= FETCH ALL MANAGERS ================= */
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await Instance.get("/agents");

      if (response.status === 200) {
        const managers = (response.data.agents || []).filter(
          (agent) => agent.role === "MANAGER",
        );

        setData(managers);
      }
    } catch (error) {
      console.error("Error fetching Managers:", error);
      message.error("Failed to fetch Managers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const updateStatus = async (agentId, checked) => {
    try {
      const status = checked ? "ACTIVE" : "INACTIVE";

      const response = await Instance.patch(`/agents/${agentId}/status`, {
        status,
      });

      if (response.status === 200) {
        message.success(`Manager ${status.toLowerCase()} successfully`);

        setData((prev) =>
          prev.map((item) =>
            item._id === agentId ? { ...item, status } : item,
          ),
        );
      }
    } catch (error) {
      console.error(error);
      message.error("Failed to update status");
    }
  };

const handleModalClick = async (key, record) => {
  setSelectedData(record);

  if (key === "edit") {
    setShowEditModal(true);
  }

  else if (key === "addTarget") {
    setTargetId(null);
    setTargetAmount("");
    setApplicableFrom("");
    setShowTargetModal(true);
  }

  else if (key === "editTarget") {
    await openTargetModal(record);
  }

 
};

const openTargetModal = async (record) => {
  try {
    setTargetLoading(true);

    const response = await Instance.get(
      `/agents/${record._id}/targets`
    );

    const currentTarget = response?.data?.currentTarget;

    if (!currentTarget) {
      message.warning("No target found for this manager");
      return;
    }

    setTargetId(currentTarget._id);

    setTargetAmount(
      currentTarget.targetAmount || ""
    );

    setApplicableFrom(
      currentTarget.applicableFrom
        ? currentTarget.applicableFrom.split("T")[0]
        : ""
    );

    setShowTargetModal(true);
  } catch (error) {
    console.error(error);
    message.error("Failed to fetch target");
  } finally {
    setTargetLoading(false);
  }
};

 const menu = (record) => (
  <Menu onClick={({ key }) => handleModalClick(key, record)}>
    <Menu.Item key="edit">
      Edit Manager
    </Menu.Item>

    <Menu.Item key="addTarget">
      Add New Target
    </Menu.Item>

    <Menu.Item key="editTarget">
      Edit Current Target
    </Menu.Item>

  </Menu>
);
 
const saveTarget = async () => {
  if (!targetAmount || !applicableFrom) {
    return message.error(
      "Target Amount and Applicable From are required"
    );
  }

  try {
    setTargetLoading(true);

    let response;

    if (targetId) {
      response = await Instance.put(
        `/agents/${selectedData._id}/targets/${targetId}`,
        {
          targetAmount: Number(targetAmount),
          applicableFrom,
        }
      );

      message.success("Target updated successfully");
    } else {
      response = await Instance.post(
        `/agents/${selectedData._id}/targets`,
        {
          targetAmount: Number(targetAmount),
          applicableFrom,
        }
      );

      message.success("New target added successfully");
    }

    if (
      response.status === 200 ||
      response.status === 201
    ) {
      fetchData();

      setShowTargetModal(false);

      setTargetId(null);
      setTargetAmount("");
      setApplicableFrom("");
    }
  } catch (error) {
    console.error(error);
    message.error("Failed to save target");
  } finally {
    setTargetLoading(false);
  }
};
  

  /* ================= TABLE COLUMNS ================= */
 const columns = [
  {
    title: "Manager Name",
    dataIndex: "agentName",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Mobile Number",
    dataIndex: "number",
  },
  {
    title: "Total Target",
    dataIndex: "totalTarget",
    render: (value) => `₹${value || 0}`,
  },
  {
    title: "Status",
    render: (_, record) => (
      <Switch
        checked={
          (record.status || "ACTIVE") ===
          "ACTIVE"
        }
        checkedChildren="Active"
        unCheckedChildren="Inactive"
        onChange={(checked) =>
          updateStatus(record._id, checked)
        }
      />
    ),
  },
  {
    title: "Actions",
    render: (_, record) => (
      <Dropdown
        overlay={menu(record)}
        trigger={["click"]}
      >
        <BsThreeDots
          style={{
            fontSize: 20,
            cursor: "pointer",
          }}
        />
      </Dropdown>
    ),
  },
];

  return (
    <div className="agents-page mt-5">
      <div className="agents-table mt-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h1 className="agents-heading-h1">Managers List</h1>
          <button className="surve-export-btn" onClick={handleShow}>
            <FaPlus /> Add New Manager
          </button>
        </div>

        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          rowKey="_id"
          scroll={{ x: "max-content" }}
        />
      </div>

      <AddManagerModal
        show={showModal}
        handleClose={handleClose}
        fetchData={fetchData}
      />
      <ViewAgentModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        agentData={selectedData}
      />
      <EditManagerModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        managerData={selectedData}
        fetchData={fetchData}
      />

      <AntModal
  open={showTargetModal}
  onCancel={() => setShowTargetModal(false)}
  footer={null}
  centered
  title={`${
  targetId
    ? "Edit Current Target"
    : "Add New Target"
} - ${selectedData?.agentName || ""}`}
>
  <div className="mb-3">
    <label className="form-label">
      Target Amount *
    </label>

    <input
      type="number"
      className="form-control"
      value={targetAmount}
      onChange={(e) =>
        setTargetAmount(e.target.value)
      }
    />
  </div>

  <div className="mb-3">
    <label className="form-label">
      Applicable From *
    </label>

    <input
      type="date"
      className="form-control"
      value={applicableFrom}
      onChange={(e) =>
        setApplicableFrom(e.target.value)
      }
    />
  </div>

  <div className="d-flex justify-content-end gap-2">
    <button
      className="users-discard-button"
      onClick={() =>
        setShowTargetModal(false)
      }
    >
      Cancel
    </button>

    <button
      className="users-save-button"
      onClick={saveTarget}
      disabled={targetLoading}
    >
      {targetLoading ? (
  <>
    <Spin size="small" /> Saving...
  </>
) : targetId ? (
  "Update Target"
) : (
  "Add Target"
)}
    </button>
  </div>
</AntModal>
    </div>
  );
};

export default ManagersList;
